<template>
  <b-col>
    <b-card
      v-if="!id"
      sub-title="Moje veľkonočné pohľadničky"
      header="Veľká Noc"
      text-variant="dark"
    >
      <b-row>
        <b-col
          v-for="(item, index) in data"
          :key="index"
          deck
          sm="12"
          md="6"
          lg="4"
          style="margin-top:5px"
        >
          <postcard
            :source-pictutes="data[index].pictutes"
            :title-img="data[index].title"
            :details-img="data[index].details"
            :size-img="data[index].size"
            :material-img="data[index].material"
            :kind-img="data[index].img"
            :path-img="/velkanoc/ + data[index].id"
          />
        </b-col>
      </b-row>
    </b-card>
    <router-view/>
  </b-col>
</template>

<script>
import Picture from "./Picture"
import { ref, watch } from "@vue/composition-api"
export default {
  name: 'Velkanoc',
  components: {
    'postcard': Picture
  },
  setup(params, context) {
    const id = ref(false)
    if (context.root.$route.params.id) {
      id.value = true
    }
    watch(() => context.root.$route.params.id, (value) => { value ? id.value = true : id.value = false })
    const data = ref([
      {
        pictutes: ['/static/images/velkanoc/velkanoc48.jpg','/static/images/velkanoc/velkanoc49.jpg','/static/images/velkanoc/velkanoc50.jpg'],
        title: "Kaktus - 3,60 €",
        subtitle: "Pohľadnica",
        details: "....milá pohľadnička s rozkvitnutým kaktusom, motív som vytvorila technikou decoupage, ručne vyrezala a nalepila v 3D efekte na biely pohľadnicový základ, ĎAKUJEM je pečiatka. Posielam s ručne robenou obálkou na mieru.",
        size: "15 x 10,5 cm",
        material: "obyčajný papier, kartón",
        kind: "decoupage, cardmaking, lepenie",
        id: 16
      },
      {
        pictutes: ['/static/images/velkanoc/velkanoc46.jpg','/static/images/velkanoc/velkanoc47.jpg'],
        title: "Sukulent - 3,60 €",
        subtitle: "Pohľadnica",
        details: "...minimalistická pohľadnička s motívom sukulentu v milom bodkovanom črepníku, motív bol vytvorený technikou decoupage, ručne vyrezaný a nalepený v 3D efekte, prizdobené drobnou mašličkou z ľanovej šnúrky. Posielam s ručne robenou obálkou na mieru.",
        size: "15 x 10,5 cm",
        material: "obyčajný papier, špagát, kartón",
        kind: "decoupage, cardmaking, lepenie",
        id: 15
      },
      {
        pictutes: ['/static/images/velkanoc/velkanoc42.jpg','/static/images/velkanoc/velkanoc43.jpg'],
        title: "Veľkonočný zajačik - 3,60 €",
        subtitle: "Pohľadnica",
        details: "...jednoduchá a milá veľkonočná pohľadnička s motívom zajačika na lúke, ten bol vytvorený technikou decoupage, ručne vyrezaný a nalepený v 3D efekte na biely pohľadnicový základ. Posielam s ručne robenou obálkou na mieru.",
        size: "15 x 10,5 cm",
        material: "obyčajný papier, špagát, kartón",
        kind: "decoupage, cardmaking, lepenie",
        id: 14
      },
      {
        pictutes: ['/static/images/velkanoc/velkanoc44.jpg','/static/images/velkanoc/velkanoc45.jpg'],
        title: "Veľkonočný zajko - 3,80 €",
        subtitle: "Pohľadnica",
        details: "...jednoduchá veľkonočná pohľadnička s prírodným nádychom, bola ozdobená zajkom, ktorého som vytvorila technikou decoupage, ručne vyrezala a nalepila v 3D efekte na biely pohľadnicový základ. Pohľadničku som dozdobila pečiatkou, bielohnedou šnúrkou a listom. S pohľadničkou posielam ručne robenú obálku na mieru.",
        size: "14 x 10,5 cm",
        material: "obyčajný papier, špagát, kartón",
        kind: "decoupage, cardmaking, lepenie",
        id: 13
      },
      {
        pictutes: ['/static/images/velkanoc/velkanoc1.jpg','/static/images/velkanoc/velkanoc2.jpg','/static/images/velkanoc/velkanoc3.jpg'],
        title: "Krásna jar - 5,40 €",
        subtitle: "Pohľadnica",
        details: "...milá jarná pohľadnica s motívom jabloňových kvietkov, tie boli vytvorené technikou decoupage, ručne vyrezané a nalepené v 3D efekte na biely pohľadnicový základ, pohľadnička obsahuje text v sivej farbe - Krásnu jar-. Posielam s pevnou ručne robenou obálkou.",
        size: "15 x 10,5 cm",
        material: "obyčajný papier, kartón",
        kind: "decoupage, cardmaking, lepenie",
        id: 12
      },
      {
        pictutes: ['/static/images/velkanoc/velkanoc4.jpg','/static/images/velkanoc/velkanoc5.jpg','/static/images/velkanoc/velkanoc6.jpg'],
        title: "Veľkonočné vajíčka - 3,60 €",
        subtitle: "Pohľadnica",
        details: "...otváracia pohľadnica v minimalistickom štýle s motívom vajíčok s florálnym zdobením, ktoré som vytvorila technikou decoupage, ručne vyrezala a nalepila v 3D efekte na biely ručne robený pohľadnicový základ. Pohľadničku som dozdobila ľanovou šnúrkou a pečiatkou. Posielam s ručne robenou obálkou na mieru.",
        size: "14 x 10,5 cm",
        material: "obyčajný papier, kartón, špagát",
        kind: "decoupage, cardmaking, lepenie",
        id: 11
      },
      {
        pictutes: ['/static/images/velkanoc/velkanoc8.jpg','/static/images/velkanoc/velkanoc7.jpg'],
        title: "Zlatý dážď venček - 4,50 €",
        subtitle: "Pohľadnica",
        details: "...jemná jarná pohľadnička so zlatým dažďom, ten som vytvorila technikou decoupage, ručne vyrezala a nalepila v 3D efekte, prizdobila bielou ľanovou mašličkou. Posielam s ručne robenou obálkou na mieru.",
        size: "15 x 10,5 cm",
        material: "obyčajný papier, špagát, kartón",
        kind: "decoupage, lepenie, cardmaking",
        id: 10
      },
      {
        pictutes: ['/static/images/velkanoc/velkanoc9.jpg','/static/images/velkanoc/velkanoc10.jpg','/static/images/velkanoc/velkanoc11.jpg','/static/images/velkanoc/velkanoc12.jpg'],
        title: "Čerešňová vetvička - 4,50 €",
        subtitle: "Pohľadnica",
        details: "...otváracia pohľadnica s motívom čerešňových vetvičiek, tie boli vytvorené technikou decoupage, precízne ručne vyrezané a nalepené v 3D efekte. Pohľadnica je vrstvená, vnútro a zadná strana bez textov v bielej farbe, posielam s ručne robenou obálkou.",
        size: "cca 14 x 14 cm",
        material: "obyčajný papier, kartón",
        kind: "decoupage, lepenie, cardmaking",
        id: 9
      },
      {
        pictutes: ['/static/images/velkanoc/velkanoc13.jpg','/static/images/velkanoc/velkanoc14.jpg','/static/images/velkanoc/velkanoc15.jpg','/static/images/velkanoc/velkanoc16.jpg','/static/images/velkanoc/velkanoc17.jpg'],
        title: "Bahniatka - 5,40 €",
        subtitle: "Pohľadnica",
        details: "...pohľadnička s jarným venčekom, vytvorený je z ručne vyrezaných bahniatok a papierového tulipánika a lístkov, použila som techniku decoupage a venček naaranžovala v 3D efekte. Ozdobená je ľanovou mašličkou.  Pohľadnička je vrstvená, bez textov, v bielej farbe. Posielam s ručne robenou obálkou na mieru.",
        size: "13,5 x 13,5 cm",
        material: "obyčajný papier, kartón, špagát",
        kind: "decoupage, lepenie, cardmaking",
        id: 8
      },
      {
        pictutes: ['/static/images/velkanoc/velkanoc18.jpg','/static/images/velkanoc/velkanoc19.jpg','/static/images/velkanoc/velkanoc20.jpg'],
        title: "Zajačik - 3,60 €",
        subtitle: "Pohľadnica",
        details: "...otváracia pohľadnica s motívom zajačika, ten bol vytvorený technikou decoupage, nalepený v 3D efekte. Pohľadnica je vrstvená, vrchný papier je bielej farby s farebnými guličkami, jemne štruktúrovaný, vnútro a zadná strana bez textov v perlovo bielej farbe, posielam s ručne robenou obálkou.",
        size: "cca 15 x 10,5 cm",
        material: "obyčajný papier, archivačný papier, špagát, kartón",
        kind: "decoupage, lepenie, cardmaking",
        id: 7
      },
      {
        pictutes: ['/static/images/velkanoc/velkanoc21.jpg','/static/images/velkanoc/velkanoc22.jpg','/static/images/velkanoc/velkanoc23.jpg'],
        title: "Veľkonočné kohútiky - 4,50 € / sada",
        subtitle: "Dekorácia",
        details: "...veľkonočná dekorácia (visačky), z oboch strán s motívom kohútika, na špagátiku s mašličkou, prelakované ...cena za 3ks (1sada)",
        size: "...cca 6,5 x 4 cm",
        material: "obyčajný papier, špagát",
        kind: "decoupage, lepenie",
        id: 6
      },
      {
        pictutes: ['/static/images/velkanoc/velkanoc24.jpg','/static/images/velkanoc/velkanoc25.jpg','/static/images/velkanoc/velkanoc26.jpg','/static/images/velkanoc/velkanoc27.jpg','/static/images/velkanoc/velkanoc28.jpg','/static/images/velkanoc/velkanoc29.jpg'],
        title: "Veľkonočné vajíčka - 4 € / sada",
        subtitle: "Dekorácia",
        details: "...veľkonočné vajíčka na zavesenie, sú vytvorené technikou decoupage, z oboch strán rovnaký motív. Dajú sa zavesiť pomocou bielej šnúrky, každá kraslica má inú dĺžku šnúrky. Sú prelakované lakom na decoupage, aby boli pevné a odolné. Môžete si ich zavesiť na halúzku alebo pripevniť na balíčky pre šibačov. V sade sa nachádza 5 veľkonočných vajíčok v hnedej a béžovej farbe.",
        size: "6 x 4 cm",
        material: "kartón, špagát",
        kind: "decoupage, lepenie",
        id: 5
      },
      {
        pictutes: ['/static/images/velkanoc/velkanoc30.jpg','/static/images/velkanoc/velkanoc31.jpg','/static/images/velkanoc/velkanoc32.jpg'],
        title: "Ovečka - 3,60 €",
        subtitle: "Pohľadnica",
        details: "...milá otváracia pohľadnica s motívom ovečky, tá bola vytvorená technikou decoupage, ručne vyrezaná, nalepená v 3D efekte na ručne robený základ pohľadnice v bielej farbe. Pohľadnička je vo vnútri bez textov, na voľno previazaná prírodnou ľanovou šnúrkou. Posielam s pevnou ručne robenou obálkou na mieru.",
        size: "...15 x 10,5 cm",
        material: "obyčajný papier, kartón, špagát",
        kind: "decoupage, lepenie, cardmaking",
        id: 4
      },
      {
        pictutes: ['/static/images/velkanoc/velkanoc33.jpg','/static/images/velkanoc/velkanoc34.jpg','/static/images/velkanoc/velkanoc35.jpg','/static/images/velkanoc/velkanoc36.jpg'],
        title: "Veľkonočný venček - 4,50 €",
        subtitle: "Pohľadnica",
        details: "...pohľadnica s motívom jarného venčeka, ten bol vytvorený technikou decoupage, ručne vyrezaný a nalepený v 3D efekte. Pohľadnica je vrstvená, vnútro a zadná strana sú bielej farby bez textov, na voľno previazaná motúzikom. Posielam s pevnou ručne robenou obálkou.",
        size: "cca 14,5 x 14,5 cm",
        material: "obyčajný papier, špagát, kartón",
        kind: "decoupage, lepenie, cardmaking",
        id: 3
      },
      {
        pictutes: ['/static/images/velkanoc/velkanoc37.jpg','/static/images/velkanoc/velkanoc38.jpg'],
        title: "Zlatý dážď vetvička - 5,40 €",
        subtitle: "Pohľadnica",
        details: "...otváracia pohľadnica s motívom vetvičky zlatého dažďa, tá bola vytvorená technikou decoupage, precízne ručne vyrezaná kvietok po kvietku a nalepená v 3D efekte. Pohľadnica je vrstvená, vnútro a zadná strana bez textov v bielej farbe, posielam s ručne robenou obálkou.",
        size: "cca 10,5 x 10 cm",
        material: "obyčajný papier, kartón",
        kind: "decoupage, lepenie, cardmaking",
        id: 2
      },
      {
        pictutes: ['/static/images/velkanoc/velkanoc39.jpg','/static/images/velkanoc/velkanoc40.jpg','/static/images/velkanoc/velkanoc41.jpg'],
        title: "Venček z narcisov - 5,40 €",
        subtitle: "Pohľadnica",
        details: "...veľkonočná pohľadnica s motívom venčeka z narcisov, tie som vyrobila technikou decoupage, ručne vyrezala a nalepila v tvare venčeka v 3D efekte, pohľadničku som dozdobila mašličkou a pečiatkou - veselú veľkú noc-, posielam s ručne robenou obálkou na mieru.",
        size: "15 x 10,5 cm",
        material: "obyčajný papier, kartón, špagát",
        kind: "decoupage, lepenie, cardmaking",
        id: 1
      }
    ])
    return {
      data,
      id
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Velkanoc.vue